import { render, staticRenderFns } from "./CurtainCall.vue?vue&type=template&id=41bf5b34&"
import script from "./CurtainCall.vue?vue&type=script&lang=js&"
export * from "./CurtainCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports